// extracted by mini-css-extract-plugin
module.exports = {"settlement":"Settlements_settlement__3FoX0"};